/* Slideshow.

   The track is a native scroll-snap list, so swiping already works before this
   file loads. Everything here is addition, not foundation: auto-advance, the
   arrows, the dots, and the pause control that auto-advance obliges us to wire.

   Position is read back from scrollLeft rather than tracked in a variable. A
   visitor can move this thing by swiping, by dragging the scrollbar, by
   pressing an arrow key inside the track, or by tabbing to a slide. A variable
   would drift out of step with all of those; the scroll position cannot.

   Auto-advance stops on hover, on focus inside the section, when the tab is
   hidden, and permanently once the visitor presses pause. Under
   prefers-reduced-motion it never starts, and the button says so rather than
   claiming to be playing. */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-slideshow]');
  if (!roots.length) return;

  var reduced = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(roots, function (root) {
    var track = root.querySelector('[data-slideshow-track]');
    var slides = root.querySelectorAll('[data-slideshow-slide]');
    if (!track || slides.length < 2) return;

    var prev = root.querySelector('[data-slideshow-prev]');
    var next = root.querySelector('[data-slideshow-next]');
    var dots = root.querySelectorAll('[data-slideshow-dot]');
    var pause = root.querySelector('[data-slideshow-pause]');

    var wantsAuto = root.hasAttribute('data-slideshow-autoplay') && !reduced;
    var wait = parseInt(root.getAttribute('data-slideshow-interval'), 10) || 5000;

    var timer = null;
    var stoppedByUser = false;
    var held = false;

    function current() {
      // Nearest slide to the centre of the scrollport, which is what
      // scroll-snap-align: center actually settles on.
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var c = slides[i].offsetLeft + slides[i].offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }

    function go(i) {
      var n = slides.length;
      var target = slides[((i % n) + n) % n];
      // scrollLeft rather than scrollIntoView: scrollIntoView on a horizontal
      // track also scrolls the page vertically to bring the slide into view.
      track.scrollLeft = target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2;
    }

    function sync() {
      var at = current();
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-selected', i === at ? 'true' : 'false');
      }
      if (prev) prev.hidden = false;
      if (next) next.hidden = false;
    }

    function tick() { go(current() + 1); }

    function run() {
      stop();
      if (!wantsAuto || stoppedByUser || held) return;
      timer = setInterval(tick, wait);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });

    Array.prototype.forEach.call(dots, function (dot) {
      dot.addEventListener('click', function () {
        go(parseInt(dot.getAttribute('data-slideshow-index'), 10) || 0);
      });
    });

    if (pause) {
      if (!wantsAuto) {
        // Reduced motion, or autoplay switched off. Either way it is not
        // playing, and the control should not pretend otherwise.
        pause.setAttribute('aria-pressed', 'true');
        pause.setAttribute('aria-label', 'Play slideshow');
      }
      pause.addEventListener('click', function () {
        stoppedByUser = !stoppedByUser;
        pause.setAttribute('aria-pressed', stoppedByUser ? 'true' : 'false');
        pause.setAttribute('aria-label', stoppedByUser ? 'Play slideshow' : 'Pause slideshow');
        if (!stoppedByUser) { wantsAuto = true; }
        run();
      });
    }

    var settle;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(sync, 90);
    }, { passive: true });

    root.addEventListener('mouseenter', function () { held = true; stop(); });
    root.addEventListener('mouseleave', function () { held = false; run(); });
    root.addEventListener('focusin', function () { held = true; stop(); });
    root.addEventListener('focusout', function () {
      if (!root.contains(document.activeElement)) { held = false; run(); }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { run(); }
    });

    sync();
    run();
  });
})();
